export default __webpack_public_path__ + "static/media/thumb_down.1f6d888e.svg";